<div class="pt-2 md:pt-3 md:px-4 px-2 pb-8" data-testid="communication-category-list-page">
  <div class="flex justify-content-between">
    <h1
      class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1"
      aria-label="communication-categories-page-header">
      {{ 'COMMUNICATION_CATEGORIES.LIST.PAGE_TITLE' | translate }}
    </h1>

    <div class="flex align-items-center justify-content-end relative">
      <p-button
        icon="fa fa-plus"
        [label]="'COMMUNICATION_CATEGORIES.LIST.CREATE' | translate"
        styleClass="surface-0 p-button-outlined text-sm p-2 hidden md:inline-flex"
        (onClick)="openCreate()"
        aria-label="create-communication-category-button"
        data-testid="create-communication-category-button" />
      <p-button
        icon="fa fa-plus"
        styleClass="h-2rem w-2rem surface-0 p-button-outlined p-1 md:hidden"
        (onClick)="openCreate()"
        aria-label="create-communication-category-button-mobile"
        data-testid="create-communication-category-button-mobile" />
    </div>
  </div>

  <div class="mt-1">
    <app-breadcrumb />
  </div>

  <div class="surface-0 shadow-2 border-round my-3" aria-label="communication-categories-content">
    <div class="p-3 flex flex-wrap align-items-center justify-content-between border-bottom-1 border-300 gap-2">
      <span class="text-900 font-normal text-sm" aria-label="communication-categories-total-count">
        {{ 'ADMIN.COMMON.TOTAL' | translate }} -
        <strong>{{ tableData.getValue().length }}</strong>
        {{ 'COMMUNICATION_CATEGORIES.LIST.ITEMS_LABEL' | translate }}
      </span>
      <div class="flex flex-wrap align-items-center gap-2" data-testid="communication-category-list-filters">
        <p-iconfield iconPosition="left">
          <p-inputicon styleClass="fa fa-search" />
          <input type="text" pInputText
            [placeholder]="'common.PLACEHOLDER.SEARCH' | translate"
            class="text-sm w-full md:w-14rem"
            [(ngModel)]="searchText"
            (input)="onSearch($any($event.target).value)"
            aria-label="search-communication-category-list-input"
            data-testid="search-communication-category-list-input" />
        </p-iconfield>
        <p-select
          [options]="statusFilters"
          [(ngModel)]="selectedStatusFilter"
          optionLabel="name"
          optionValue="value"
          styleClass="text-sm w-full md:w-11rem"
          (onChange)="onStatusFilterChange($event.value)"
          aria-label="status-filter-dropdown"
          data-testid="status-filter-dropdown">
          <ng-template pTemplate="selectedItem" let-selected>
            <div class="text-sm">{{ selected?.name | translate }}</div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="text-sm">{{ item.name | translate }}</div>
          </ng-template>
        </p-select>
        @if (showAuditLogsFeature) {
          <div class="hidden md:inline-block">
            <p-button (click)="showAuditTrail()" [label]="'Show Logs'" icon="fa fa-history" styleClass="text-sm p-button-text white-space-nowrap" aria-label="show-logs-button" />
          </div>
          <div class="md:hidden">
            <p-button (click)="showAuditTrail()" icon="fa fa-history" styleClass="p-button-outlined" aria-label="show-logs-button-mobile" />
          </div>
        }
      </div>
    </div>

    <app-data-grid
      [hidden]="loading | async"
      [columnData]="tableData"
      [columns]="columns"
      [paginator]="false"
      [totalRecords]="totalRecordLength"
      [EmptyState]="emptyStateComponent$"
      [selectable]="selectAllData"
      [resizableColumns]="true"
      [columnResizeMode]="'expand'"
      (onAction)="onActionEvent($event)"
      [gridName]="'communication-category-list'"
      data-testid="communication-category-data-grid"
      aria-label="communication-categories-data-grid" />
  </div>
</div>

<ff-communication-category-form
  [visible]="showFormDialog()"
  [activeCategory]="activeCategory()"
  [tenantId]="tenantId"
  (changed)="onFormSaved()"
  (dialogClose)="closeForm()"
  data-testid="communication-category-form-dialog" />

<p-confirmDialog aria-label="communication-category-delete-confirm-dialog" />

@if (showAuditTrailSidebar && showAuditLogsFeature) {
  <p-drawer
    [visible]="showAuditTrailSidebar"
    position="right"
    [modal]="true"
    [appendTo]="'body'"
    [autoZIndex]="true"
    [blockScroll]="true"
    [showCloseIcon]="false"
    styleClass="w-full md:w-30rem"
    (onHide)="hideAuditTrail()"
    aria-label="audit-trail-sidebar"
    header="Activity Log"
    data-testid="audit-trail-sidebar">
    <ng-template pTemplate="content">
      <fitness-force-audit-trail-mini entityType="communication_category_mst"
        [entityId]="activeCategory()?.id"
        [tenantId]="tenantId"
        [tenantData]="[]"
        [maxEvents]="10"
        [showStats]="true"
        [showFilters]="true"
        [showPagination]="true"
        height="100vh"
        title="Communication Category Activity Log"
        [showCloseButton]="true"
        (closeEvent)="hideAuditTrail()"
        data-testid="audit-trail-mini-component" />
    </ng-template>
  </p-drawer>
}
